import React from "react";
import { Field, reduxForm } from "redux-form";
import i18n from "../../../../lib/i18n/i18n";
import Toggle from "react-toggle";
import {
  ToggleContainer,
  ToggleText,
  AdditionalDetailsContainer,
  Fields,
} from "../permissions.styles";

const renderToggle = ({ input, label }) => {
  const isHebrew = i18n.language === "he";
  return (
    <ToggleContainer isRtl={isHebrew}>
      <ToggleText>{label}</ToggleText>
      <Toggle checked={input.value} onChange={input.onChange} />
    </ToggleContainer>
  );
};

const StudentsPermissions = () => {
  return (
    <Fields>
      <AdditionalDetailsContainer>
        <Field
          label="הכנסות מתלמידים"
          component={renderToggle}
          name="incomesFromStudents"
        />
        <Field label="ספקים" component={renderToggle} name="providers" />
        <Field
          label="סוגי הוצאות"
          component={renderToggle}
          name="expensesTypes"
        />
        <Field
          label="גופי מימון"
          component={renderToggle}
          name="fundingBodies"
        />
        <Field label="לקוחות" component={renderToggle} name="clients" />
        <Field label="הכנסות" component={renderToggle} name="incomes" />
        <Field
          label="יצירת מסמך הכנסה"
          component={renderToggle}
          name="createIncome"
        />
        <Field
          label="יצירת מסמך כספי תלמיד"
          component={renderToggle}
          name="createStudentIncome"
        />
        <Field
          label="חשבונית"
          component={renderToggle}
          name="isAllowedInvoice"
        />
        <Field label="קבלה" component={renderToggle} name="isAllowedReceipt" />
        <Field
          label="חשבונית/קבלה"
          component={renderToggle}
          name="isAllowedInvoiceReceipt"
        />
        <Field
          label="חשבונית זיכוי"
          component={renderToggle}
          name="isAllowedCreditInvoice"
        />
        <Field
          label="קבלה זיכוי"
          component={renderToggle}
          name="isAllowedCreditReceipt"
        />
        <Field
          label="חשבונית/קבלה זיכוי"
          component={renderToggle}
          name="isAllowedCreditInvoiceReceipt"
        />
        <Field label="הנחה" component={renderToggle} name="isAllowedDiscount" />
        <Field label="חיוב" component={renderToggle} name="isAllowedBilling" />
      </AdditionalDetailsContainer>
    </Fields>
  );
};

export default reduxForm({
  form: "permissions", // a unique identifier for this form
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  enableReinitialize: true, // this is needed!!
})(StudentsPermissions);
